import { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FILE_URL } from '../hooks/useApi';

const RaffleCard = ({ raffle }) => {
  const [timeToLock, setTimeToLock] = useState('0d 0h 0m 0s');
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const now = date;
    const limit = raffle?.isStarted ? raffle?.end : raffle?.start;
    let milliseconds = limit.getTime() - now.getTime();
    if (milliseconds < 0) {
      if (raffle.isStarted) {
        raffle.isClosed = true;
      } else {
        raffle.isStarted = true;
      }
    } else {
      let seconds = milliseconds / 1000;
      let minutes = seconds / 60;
      let hours = minutes / 60;
      let days = Math.floor(hours / 24);
      seconds = Math.floor(seconds % 60);
      minutes = Math.floor(minutes % 60);
      hours = Math.floor(hours % 24);
      setTimeToLock(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      if (raffle.isStarted) {
        raffle.isClosed = false;
      }
    }

    const interval = setInterval(() => {
      if (raffle) {
        setDate(new Date());
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [date]);

  return (
    <Col lg='4' md='6'>
      <Link to={`raffle-details/${raffle?.key.toString()}`}>
        <Card className='bg-dark text-light raffle-card '>
          {raffle.key.toString() ===
          '4t5VtY2thiXM1E2hPRu4YoLKdoz6iaMf3bkb5McRmcKH' ? (
            <Card.Img variant='top' src='/temples_raffle.webp' />
          ) : (
            <Card.Img variant='top' src={FILE_URL + raffle.image} />
          )}

          <Card.Body>
            <Card.Title>{raffle.name}</Card.Title>
            <Card.Text>
              {raffle?.isClosed ? (
                <Row className='flex justify-content-center my-3'>
                  <Col sm='5' className='text-center m-0 '>
                    {' '}
                    <p className='bids'>
                      # Entries: {raffle?.participants?.length}
                    </p>
                  </Col>
                  <Col sm='5' className='text-center m-0 '>
                    <p className='bids'># Winners: {raffle?.winners}</p>{' '}
                  </Col>
                </Row>
              ) : (
                <>
                  <p>{raffle?.price.toFixed(1)} $GOD/ticket</p>
                  {/* <p>{ days }d  { hours }h   { minutes }m   { seconds }s</p> */}
                  <p>
                    {' '}
                    {!raffle.isStarted ? (
                      <span style={{ fontSize: '15px' }}>Starting in </span>
                    ) : (
                      <span style={{ fontSize: '15px' }}>Ending in </span>
                    )}{' '}
                    {timeToLock}
                  </p>
                </>
              )}

              <div className='status'>
                {' '}
                {raffle.isClosed ? 'CLOSED!' : null}{' '}
              </div>
            </Card.Text>
            <Button variant='outline-danger'>
              {raffle.isClosed ? 'VIEW WINNERS' : 'JOIN THIS RAFFLE'}
            </Button>
          </Card.Body>
        </Card>
      </Link>
    </Col>
  );
};
export default RaffleCard;
